import { QuantitySavingsQuote, QuantitySavingsTier } from 'editor/src/store/quantitySavings/types';

export interface NextQuantitySavingsTier {
  tier: QuantitySavingsTier;
  additionalQuantity: number;
}

/** The next band up that saves something and how many more items reach it; undefined past `maxQuantity`. */
function getNextQuantitySavingsTier(quote: QuantitySavingsQuote): NextQuantitySavingsTier | undefined {
  // A band that saves nothing (an exact tier priced at or above the variant) is no reason to add items.
  const nextSaving = quote.tiers.slice(quote.activeTierIndex + 1).find((candidate) => candidate.savingText);
  if (!nextSaving) {
    return undefined;
  }
  // With a quantity increment the band starts, for this shopper, at the first quantity the cart accepts.
  const step = quote.quantityStep ?? 1;
  const from = quote.minQuantity ?? 1;
  const target = from + Math.ceil((nextSaving.minimumQuantity - from) / step) * step;
  if (target <= quote.quantity) {
    return undefined;
  }
  if (quote.maxQuantity !== undefined && target > quote.maxQuantity) {
    return undefined;
  }
  // A band narrower than the step is jumped over: name the band the target falls in, which saves more.
  const tier = quote.tiers.reduce(
    (found, candidate) => (candidate.minimumQuantity <= target ? candidate : found),
    nextSaving,
  );
  return { tier, additionalQuantity: target - quote.quantity };
}

export default getNextQuantitySavingsTier;
